<!-- eslint-disable vue/html-self-closing -->
<template>
  <div>
    <div v-if="userAlias && projectAlias">
      <custom-select
        v-model="selectedModel"
        :options="options"
        :searchable="true"
        :filterable="false"
        :clearable="true"
        :multiple="true"
        :taggable="true"
        :push-tags="true"
        clear-search-on-select="true"
        label="title"
        :create-option="(option) => option.replace(specialCharacters, '')"
        @input="onChange"
        @open="onOpen"
        @close="onClose"
        @search="onSearch"
        ref="projectTopicSelector"
      >
        <template #footer>
          <li
            v-show="showLoader"
            ref="load"
            class="select-branch__loader text-muted"
          >
            Загрузка...
          </li>
        </template>
      </custom-select>
      <input
        name="topics"
        type="hidden"
        :value="makeValueForInput"
      />
    </div>
    <div v-else>
      <pacman-loader
        size="15"
        style="position: relative !important"
      />
    </div>
  </div>
</template>

<script>
import referenceService from '@shared/services/reference.service';
import PacmanLoader from '@shared/shared-components/shared/packman-loader';
// eslint-disable-next-line import/no-unresolved
import CustomSelect from './custom-select';

export default {
  name: 'ProjectTopicSelector',
  components: { PacmanLoader, CustomSelect },
  props: {
    userAlias: { default: null },
    projectAlias: { default: null },
    redirect: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      options: [],
      selectedModel: null,
      pages: [],
      observer: null,
      nextPage: 1,
      showLoader: true,
      hasTopics: false,
      specialCharacters: /[\${}]/g
    };
  },
  computed: {
    hasNextPage() {
      return this.nextPage < this.pages.totalPages;
    },
    makeValueForInput() {
      let values = [];

      this.selectedModel?.forEach((model) => {
        if (typeof model === 'object') {
          values.push(model?.title);
        } else {
          values.push(model);
        }
      });

      this.$emit('input', values);

      return values;
    }
  },
  mounted() {
    this.observer = new IntersectionObserver(this.infiniteScroll);
    this.getProjectSelectedTopics();
  },
  methods: {
    getOptions(callback) {
      referenceService.getRefTopics({ page: this.nextPage }).then((res) => {
        // eslint-disable-next-line no-underscore-dangle
        this.options.push(...res._embedded.options);
        this.pages = res.page;
        this.nextPage = this.pages.number + 1;
        if (callback) {
          callback();
        }
      });
    },
    getProjectSelectedTopics() {
      referenceService.getProjectTopics(this.userAlias, this.projectAlias).then((res) => {
        // eslint-disable-next-line no-underscore-dangle
        if (res._embedded) {
          // eslint-disable-next-line no-underscore-dangle
          if (res._embedded?.topicModelList.length > 0) this.hasTopics = true;
          this.selectedModel = res._embedded.topicModelList;
          this.selectedModel.forEach((model) => {
            model.title = model.value;
          });
        }
      });
    },
    onChange(e) {
      this.$emit('input', e);
      if (!this.redirect) return;
      const params = new URLSearchParams(window.location.search);
      params.set('topic', e.id);
      window.location.search = params.toString();
    },
    async onOpen() {
      await this.$nextTick();

      referenceService.getRefTopics().then((res) => {
        // eslint-disable-next-line no-underscore-dangle
        if (res._embedded) {
          // eslint-disable-next-line no-underscore-dangle
          this.options = res._embedded.options;
          this.pages = res.page;
          this.observer.observe(this.$refs.load);
        }
      });
    },
    onClose() {
      this.observer.disconnect();
      this.setDefault();
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const { scrollTop } = ul;

        const setScroll = () => {
          this.$nextTick(() => {
            ul.scrollTop = scrollTop;
          });
        };

        if (this.hasNextPage) {
          this.getOptions(setScroll);
        } else {
          this.showLoader = false;
        }
      }
    },
    onSearch(q) {
      this.removeSpecialCharactersEnable();
      if (q) {
        q = q.replace(this.specialCharacters, '');
        setTimeout(() => {
          this.observer.disconnect();
          referenceService.getRefTopics({ q }).then((res) => {
            // eslint-disable-next-line no-underscore-dangle
            if (res._embedded) {
              // eslint-disable-next-line no-underscore-dangle
              this.options = res._embedded.options;
              this.showLoader = false;
            }
          });
        }, 500);
      }
    },
    setDefault() {
      this.nextPage = 1;
      this.options = [];
      this.showLoader = true;
      this.observer.disconnect();
    },
    removeSpecialCharactersEnable() {
      const input = this.$refs.projectTopicSelector.$el.querySelector('input');

      if (!input) return;

      input.addEventListener('input', () => {
        input.value = input.value.replace(this.specialCharacters, '');
      });
    }
  }
};
</script>
